import axios from "../../config/axiosConfig";
import { BANK_RECEIPT_RETURN_REQUEST_FAILURE, BANK_RECEIPT_RETURN_REQUEST, CREATE_BANK_RECEIPT_RETURN, GET_BANK_RECEIPT_RETURNS,
  UPDATE_BANK_RECEIPT_RETURN, DELETE_BANK_RECEIPT_RETURN, BANK_RECEIPT_RETURN_REQUEST_SUCCESS, GET_BANK_RECEIPT_RETURNS_PAGE } from "../types";
import { Entry_Type } from "@/utils";

export const getBankReceiptReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/bank-receipt-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_RECEIPT_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoBankReceiptReturn = (bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(bookId) {
        params = { ...params, bookId: bookId };
      }
      const response = await axios.get("/bank-receipt-return/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getBankReceiptReturns = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/bank-receipt-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_RECEIPT_RETURNS, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankReceiptReturnByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/bank-receipt-return/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getBankReceiptReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
    
      return axios.get(`/bank-receipt-return/get/${id}`).then((response) => {
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankReceiptReturn = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
      axios.post("/bank-receipt-return/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_BANK_RECEIPT_RETURN, payload: response.data });
        } else {
          dispatch({
            type: BANK_RECEIPT_RETURN_REQUEST_FAILURE,
            error: "Bank Receipt create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBankReceiptReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
      const { auth } = getState();
      axios.put("/bank-receipt-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Receipt?.Company_Id || auth.company?.id,
            finyearId: data.Receipt?.Finyear_Id || auth.finyear?.id,
            customerId: data.Receipt?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BANK_RECEIPT_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: BANK_RECEIPT_RETURN_REQUEST_FAILURE,
            error: "Bank Receipt update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBankReceiptReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST });
      const { auth } = getState();
      axios.delete(`/bank-receipt-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BANK_RECEIPT_RETURN, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { bankReceiptReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getBankReceiptReturnsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_RECEIPT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPaymentDetailsByBankReceiptReturnIds = (ids) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        transIds: ids,
        billType: Entry_Type.BANK_RECEIPT_RETURN
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-multy-ids`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};